import React from 'react';
import { TIME_FORMAT_DISPLAY } from '@constants';
import useFormField from '@hooks/useFormField';
import { Form } from 'antd';
import TimePicker from 'rc-time-picker';

import 'rc-time-picker/assets/index.css';
import './TimePickerField.scss';

const TimePickerField = (props) => {
    const {
        width,
        size = "small",
        format,
        className,
        label,
        fieldName,
        disabled,
        disabledMinutes,
        disabledHours,
        onSelect,
        onChange,
        validateTrigger,
        value,
        defaultValue,
        onClick,
        required,
        requiredMsg,
    } = props;

    const timeFormat = format || TIME_FORMAT_DISPLAY;
    const { rules, placeholder } = useFormField({ ...props, required, requiredMsg });

    const sizeClass = size === 'large' ? 'ant-timepicker-large' : size === 'small' ? 'ant-timepicker-small' : 'ant-timepicker-middle';


    return (
        <Form.Item label={label} className={className} name={fieldName} rules={rules} validateTrigger={validateTrigger}>
            <TimePicker
                placeholder={placeholder}
                onSelect={onSelect}
                disabledHours={disabledHours}
                disabledMinutes={disabledMinutes}
                style={{ width: width || '60%' }}
                format={timeFormat}
                disabled={disabled}
                onChange={onChange}
                value={value}
                defaultValue={defaultValue}
                onClick={onClick}
                className={`ant-timepicker ${sizeClass} ${disabled ? 'rc-time-picker-disabled' : ''}`}
                popupClassName="ant-timepicker-popup"
                showSecond={false}
                minuteStep={1}
                hideDisabledOptions={true}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
            />
        </Form.Item>
    );
};

export default TimePickerField;
